import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { acceptAgreement } from '../../ApiController/ApiService';

const PlatformAgreementModal = ({ agreementData, onAccepted }) => {
    const [fullName, setFullName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    if (!agreementData || !agreementData.agreement) return null;

    const { agreement } = agreementData;

    const handleAccept = async () => {
        if (!fullName.trim()) {
            setError('Please enter your full legal name to accept.');
            return;
        }

        try {
            setLoading(true);
            setError('');
            await acceptAgreement({
                agreementId: agreement._id,
                fullName: fullName.trim()
            });

            Swal.fire({
                title: 'Agreement Accepted',
                text: 'Thank you! You can now proceed to use the platform.',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });

            if (onAccepted) {
                onAccepted();
            }
        } catch (err) {
            console.error('Accept agreement failed:', err);
            setError(err.response?.data?.message || err.message || 'Failed to accept agreement. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl overflow-hidden border border-gray-200 animate-fadeIn">
                {/* Header */}
                <div className="px-6 py-5 border-b border-gray-200">
                    <h2 className="text-xl sm:text-2xl font-bold text-[#10194E]">
                        {agreement.title || 'Platform Agreement'}
                    </h2>
                </div>

                {/* Body */}
                <div className="p-6 space-y-4">
                    <p className="text-sm text-gray-600 leading-relaxed">
                        Please review and accept our updated terms of service before continuing to use NebuDash.
                    </p>

                    {/* Agreement Box */}
                    <div className="bg-[#F8FAFC] border border-gray-200 rounded-lg p-4 max-h-48 overflow-y-auto">
                        <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
                            {agreement.body || 'By accepting, the posting user agrees to the platform terms for posting loads and paying for completed deliveries.'}
                        </p>
                    </div>

                    <div className="border-t border-gray-100 pt-3">
                        <label className="block text-sm font-semibold text-gray-800 mb-2">
                            Type your full legal name to accept:
                        </label>
                        <input
                            type="text"
                            placeholder="John Doe"
                            value={fullName}
                            onChange={(e) => {
                                setFullName(e.target.value);
                                if (error) setError('');
                            }}
                            disabled={loading}
                            className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#6F1AFF] focus:border-transparent text-sm disabled:bg-gray-100"
                        />
                        {error && (
                            <p className="text-red-500 text-xs mt-1.5 font-medium">{error}</p>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
                    <button
                        type="button"
                        onClick={handleAccept}
                        disabled={loading || !fullName.trim()}
                        className="px-6 py-2.5 rounded-lg bg-[#6B7280] hover:bg-[#4B5563] text-white font-medium text-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 shadow-sm"
                    >
                        {loading && (
                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                        )}
                        <span>I Accept & Agree</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlatformAgreementModal;
